import { IData } from "../common";

export class ResourceUrlService {
    static generateUrlToShowResourceInItsTaskDataTable(resource: IData): string {
        return `${window.location.origin}/admin/projects/${resource.projectObject?.name}/${resource.model?.name}/data/${resource.status}?resourceStatus=${resource.status}&resourceOffset=1&resourceLimit=10&project=${resource.model.project}&model=${resource.model._id}&type=${resource.model.type}&resourceSortOrder=descending&resourceSortField=statusLastModifiedAt&resourceId=${resource._id}`;
    }
}